export const assetBill = {
  id: 223,
  height: 410801,
  data: {
    icon: "/imgs/icons/asset/bill.svg",
    about: "For educational purposes only.",
  },
};
